import React from "react";
import '../css/Projetos.css'
import dkconsorcio from '../images/dkconsorcio.jpeg'
import certificado from '../images/certificado.jpeg'

const projetos = [
  {
    nome: "DK Consorcio",
    foto: dkconsorcio,
    linkProjeto: "https://dkconsorcio.netlify.app",
    linkGithub: null,
    github: false
  },
  {
    nome: "Certificado Alura",
    foto: certificado,
    linkProjeto: "https://github.com/douglasarthurr/certificado-alura",
    linkGithub: "https://github.com/douglasarthurr/certificado-alura",
    github: true
  },
];

function Projetos() {
  return (
    <div className="containerProjetos">
      <h1 className="titleH">Projetos</h1>
      <div className="projetos">
        {projetos.map((projeto, index) => (
          <div key={index} className="projeto">
            <h2 className="titleprojeto">{projeto.nome}</h2>
            <img className="imagemProjeto" src={projeto.foto} alt={projeto.nome} />
            <div className="links">
              <a className="link" href={projeto.linkProjeto} target="_blank" rel="noopener noreferrer">
                Link do Projeto
              </a>
              {projeto.github && (
                <a className="link" href={projeto.linkGithub} target="_blank" rel="noopener noreferrer">
                  Repositório GitHub
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projetos;
